import { Box, Theme, useMediaQuery } from '@mui/material';

import { PageTabs, SingleSelectDropdown } from '@/components';
import { MemberFilters } from '@/constants';
import { MemberFilterKey, OrganizationMember } from '@/types';

export type Params = {
  data: OrganizationMember[] | undefined;
  activeFilter: MemberFilterKey;
  onFilterSelection: (filter: MemberFilterKey) => void;
};

export const MemberStateFilters = ({
  onFilterSelection,
  activeFilter,
  data,
}: Params) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  const filterKeys = Object.keys(MemberFilters) as MemberFilterKey[];

  return isMobile ? (
    <Box>
      <SingleSelectDropdown
        selectedOption={activeFilter}
        options={MemberFilters}
        onSave={value => onFilterSelection(value as MemberFilterKey)}
        title={'Show: '}
      />
    </Box>
  ) : (
    <PageTabs
      tabs={filterKeys.map(key => {
        const count = data?.filter(m =>
          MemberFilters[key].states.includes(m.state),
        ).length;

        return {
          label: `${MemberFilters[key].label} ${count !== undefined ? count.toLocaleString('en-US') : ''}`,
          value: key,
          disabled: !count,
          tooltip: MemberFilters[key].tooltip,
        };
      })}
      selectedTab={activeFilter}
      onChange={(e, newVal) => onFilterSelection(newVal as MemberFilterKey)}
    />
  );
};
